import axiosInstance from "@app/config/api/config";

export async function getTemplate() {
  const res = await axiosInstance.get('templates/current');

  return res.data;
}
